import { render, staticRenderFns } from "./JobsConfiguration.vue?vue&type=template&id=682e84b6&scoped=true"
import script from "./JobsConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsConfiguration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobsConfiguration.vue?vue&type=style&index=0&id=682e84b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e84b6",
  null
  
)

export default component.exports